import { useEffect, useState } from "react";
import api from "../utils/api/axiosInstance";

/**
 * Cohort sentences for the current shortlist. Empty when the slice is
 * below 20 picks, or when budget and use case are both missing.
 */
export default function useDecisionCohort({
  productIds = [],
  categoryId = "",
  budgetMax = null,
  useCase = "",
} = {}) {
  const [stats, setStats] = useState({});
  const ids = productIds.map((id) => String(id)).filter(Boolean).join(",");
  const budget =
    budgetMax != null && budgetMax !== "" ? String(budgetMax) : "";
  const use = String(useCase || "").trim();

  useEffect(() => {
    if (!categoryId || (!budget && !use) || !ids) {
      setStats({});
      return undefined;
    }
    let cancelled = false;
    const params = new URLSearchParams();
    params.set("categoryId", categoryId);
    params.set("productIds", ids);
    if (budget) params.set("budgetMax", budget);
    if (use) params.set("useCase", use);
    api
      .get(`/decisions/cohort?${params.toString()}`)
      .then((res) => {
        if (!cancelled) setStats(res.data?.stats || {});
      })
      .catch(() => {
        if (!cancelled) setStats({});
      });
    return () => {
      cancelled = true;
    };
  }, [categoryId, budget, use, ids]);

  return stats;
}
